// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dashboard-cards[data-v-b6a468e4] {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n}\n.dashboard-cards > *[data-v-b6a468e4] {\n  width: 48%;\n}\n.orange-big-text[data-v-b6a468e4] {\n  color: var(--brand);\n  font-size: 4rem;\n  text-align: center;\n  font-weight: bold;\n}\n@media all and (max-width: 767px) {\n.dashboard-cards > *[data-v-b6a468e4] {\n    width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
